import { Column } from 'react-table';
import { useIntl } from 'react-intl'; 
import { Page } from '../../core/_models';
import { PageActionsCell } from './PageActionsCell';
import { PageCustomHeader } from './PageCustomHeader';
import { ToggleButton } from '../../../pages-details/commun-component/ToggleButton';
import { toast } from 'react-toastify';
import { patchOne } from '../../../../../services/common_requests';

const PagesColumns = (): ReadonlyArray<Column<Page>> => {
  const intl = useIntl(); // Move useIntl here to access it in components

  // Define the handleToggleChange function here without the useIntl call inside it
  const handleToggleChange = async (id: string, newIsActive: boolean) => {
    try {
      const payload = { isActive: newIsActive };
      const response = await patchOne(payload, `/pages/${id}`);

      if (response?.payload?.code === 2021) {
        toast.success(
          intl.formatMessage({
            id: 'ADMIN.COMMON.SUCCESS.PAGE_UPDATED_SUCCESSFULLY',
          }),
          {
            position: 'top-right',
            autoClose: 4000,
          }
        );
      }
    } catch (error) {
      toast.error(
        intl.formatMessage({
          id: 'ADMIN.COMMON.ERROR.STATUS_UPDATED',
        }),
        {
          position: 'top-right',
          autoClose: 4000,
        }
      );
      throw error;
    }
  };

  return [
    {
      Header: (props: any) => (
        <PageCustomHeader
          tableProps={props}
          title={intl.formatMessage({ id: 'COLUMNS.NAME' })}
          className="min-w-125px"
        />
      ),
      id: 'translations[0].title',
      Cell: ({ row }: { row: any }) => (
        <span>{row.original.translations?.[0]?.title}</span>
      ),
    },

    {
      Header: (props: any) => (
        <PageCustomHeader
          tableProps={props}
          title={intl.formatMessage({ id: 'COLUMNS.SLUG' })}
          className="min-w-125px"
        />
      ),
      accessor: 'slug',
    },

    {
      Header: (props: any) => (
        <PageCustomHeader tableProps={props} title="" className="text-end min-w-100px" />
      ),
      Cell: ({ row }: { row: any }) => (
        <ToggleButton
          id={row.original._id}
          isActive={row.original.isActive}
          onChange={(id, newValue) => handleToggleChange(id, newValue)} // Using handleToggleChange here
        />
      ),
      id: 'isActive',
    },

    {
      Header: (props: any) => (
        <PageCustomHeader tableProps={props} title="" className="text-end min-w-100px" />
      ),
      id: 'actions',
      Cell: ({ ...props }: any) => <PageActionsCell id={props.data[props.row.index]._id} />,
    },
  ];
};

export { PagesColumns };
